import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Button, ButtonAppearance } from '@guildeducationinc/recess';
import { clickable } from '@src/analytics';
import { SALESFORCE_NEW_REQUEST_URL } from '@src/constants';

interface RequestSupportButtonProps {
  appearance?: ButtonAppearance;
}

export const SUPPORT_BUTTON_TEXT = 'Contact Guild Support';
export const clickableProperties = {
  product: 'home',
  loggedIn: true,
  tag: 'requestSupportButton',
  external_url: SALESFORCE_NEW_REQUEST_URL,
  text: SUPPORT_BUTTON_TEXT,
  type: 'button',
  location: window.location.href,
};

/**
 * @name RequestSupportButton
 * @description A button component to request support
 */
const RequestSupportButton: React.FC<RequestSupportButtonProps> = ({ appearance = 'primary' }) => {
  const logSupportTicketClick = () => {
    clickable({ ...clickableProperties, external_url: SALESFORCE_NEW_REQUEST_URL });

    datadogRum.addAction('Click on Request Support');
  };

  return (
    <Button
      href={SALESFORCE_NEW_REQUEST_URL}
      onClick={logSupportTicketClick}
      target='_blank'
      newWindowIcon={true}
      newWindowNotification={true}
      appearance={appearance}
    >
      {SUPPORT_BUTTON_TEXT}
    </Button>
  );
};

export default RequestSupportButton;
